module.exports = __webpack_public_path__ + "img/our-mission-bg-image-01.f829337e.png";